export default __webpack_public_path__ + "static/media/coal.34f4ba60.png";